module.exports = __webpack_public_path__ + "b3666dbfad45b7109dee394532b5cd27.gif";


//////////////////
// WEBPACK FOOTER
// ../components/awkward.gif
// module id = 494
// module chunks = 0